__turbopack_context__.v({
  "container": "peA4BG_container",
  "examples": "peA4BG_examples",
  "inputContainer": "peA4BG_inputContainer",
  "row": "peA4BG_row",
  "searchIcon": "peA4BG_searchIcon",
  "searchText": "peA4BG_searchText",
});
